var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultsForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52614",
    "data-name": "Group 52614",
    transform: "translate(-728 -738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18645",
    "data-name": "Rectangle 18645",
    transform: "translate(728 738)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_8_",
    "data-name": "svgexport-7 (8)",
    transform: "translate(741.589 751.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52540",
    "data-name": "Group 52540",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90989",
    "data-name": "Path 90989",
    d: "M40.622,0H1.665A1.665,1.665,0,0,0,0,1.665V55.157a1.665,1.665,0,0,0,1.665,1.665H40.622a1.665,1.665,0,0,0,1.665-1.665V1.665A1.665,1.665,0,0,0,40.622,0ZM17.477,32.589,12.42,37.645a1.665,1.665,0,0,1-2.354,0L7.683,35.262a1.665,1.665,0,0,1,2.354-2.354l1.206,1.206,3.879-3.879a1.665,1.665,0,1,1,2.354,2.354Zm0-10.1L12.42,27.546a1.665,1.665,0,0,1-2.354,0L7.683,25.162a1.665,1.665,0,1,1,2.354-2.354l1.206,1.206,3.879-3.879a1.665,1.665,0,1,1,2.354,2.354Zm0-10.1L12.42,17.446a1.665,1.665,0,0,1-2.354,0L7.683,15.063a1.665,1.665,0,0,1,2.354-2.354l1.206,1.206,3.879-3.879a1.665,1.665,0,1,1,2.354,2.354ZM33.343,46.632H22.771a1.665,1.665,0,1,1,0-3.329H33.343a1.665,1.665,0,1,1,0,3.329Zm0-10.487H22.771a1.665,1.665,0,1,1,0-3.329H33.343a1.665,1.665,0,1,1,0,3.329Zm0-10.1H22.771a1.665,1.665,0,1,1,0-3.329H33.343a1.665,1.665,0,1,1,0,3.329Zm0-10.1H22.771a1.665,1.665,0,0,1,0-3.329H33.343a1.665,1.665,0,1,1,0,3.329Z",
    transform: "translate(0 0)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90990",
    "data-name": "Path 90990",
    d: "M421.477,5.65a5.65,5.65,0,0,0-11.3,0v4.883h11.3Z",
    transform: "translate(-364.655 0)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90991",
    "data-name": "Path 90991",
    d: "M410.276,391.015a1.665,1.665,0,0,0,.052,1.261l3.986,8.683a1.665,1.665,0,0,0,3.026,0l3.985-8.683a1.665,1.665,0,0,0,.052-1.261l-1.023-2.826H411.3Z",
    transform: "translate(-364.655 -345.107)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90992",
    "data-name": "Path 90992",
    d: "M421.477,149.131V124.906h-11.3v24.225a1.665,1.665,0,0,0,1.665,1.665h7.971A1.665,1.665,0,0,0,421.477,149.131Z",
    transform: "translate(-364.655 -111.044)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsForm);
export default __webpack_public_path__ + "static/media/ResultsForm.ec40ac98a7adacb4cc9c8535135b23a1.svg";
export { ForwardRef as ReactComponent };